import Checkbox from './checkbox';
import Radio from './radio';
import Select from './select';
import PollResults from './poll-results';
import QnaResults from './qna-results';
export default {
	Checkbox: Checkbox,
	Radio: Radio,
	Select: Select,
	PollResults: PollResults,
	QnaResults: QnaResults
}


// WEBPACK FOOTER //
// ./medscape_modules/qna/form-components/choices/index.js